/* VÆLD — Custom cursor.
   The cursor elements are CREATED IN JS and appended to <body>, so they
   can never appear as a static element in the markup before/without JS.
   They start hidden (inline opacity/visibility) and are only shown after
   the first real pointer movement, snapped exactly to the pointer. */

(function () {
  'use strict';

  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  function init() {
    if (document.querySelector('.cursor')) return; // guard against double-init

    var outer = document.createElement('div');
    var inner = document.createElement('div');
    outer.className = 'cursor cursor--outer';
    inner.className = 'cursor cursor--inner';
    outer.setAttribute('aria-hidden', 'true');
    inner.setAttribute('aria-hidden', 'true');

    // Critical inline styles so the dots are invisible and off-screen until
    // JS positions them — independent of whether cursor.css has loaded yet.
    var hide = 'position:fixed;top:0;left:0;transform:translate3d(-100px,-100px,0);' +
               'opacity:0;visibility:hidden;pointer-events:none;border-radius:50%;z-index:9999;';
    outer.style.cssText = hide;
    inner.style.cssText = hide;

    document.body.appendChild(outer);
    document.body.appendChild(inner);

    // Now that the custom cursor exists, hide the native one (via CSS class).
    document.documentElement.classList.add('has-custom-cursor');

    var target = { x: -100, y: -100 };
    var op = { x: -100, y: -100 };
    var ip = { x: -100, y: -100 };
    var placed = false;
    var visible = false;
    var rafId = null;

    function show() {
      if (visible) return;
      visible = true;
      outer.style.visibility = 'visible';
      inner.style.visibility = 'visible';
      outer.style.opacity = '1';
      inner.style.opacity = '1';
    }

    function hideCursor() {
      visible = false;
      outer.style.opacity = '0';
      inner.style.opacity = '0';
    }

    function loop() {
      op.x += (target.x - op.x) * 0.16;
      op.y += (target.y - op.y) * 0.16;
      ip.x += (target.x - ip.x) * 0.55;
      ip.y += (target.y - ip.y) * 0.55;
      outer.style.transform = 'translate3d(' + op.x + 'px,' + op.y + 'px,0) translate(-50%,-50%)';
      inner.style.transform = 'translate3d(' + ip.x + 'px,' + ip.y + 'px,0) translate(-50%,-50%)';
      rafId = requestAnimationFrame(loop);
    }

    window.addEventListener('mousemove', function (e) {
      target.x = e.clientX;
      target.y = e.clientY;
      if (!placed) {
        placed = true;
        op.x = ip.x = e.clientX;
        op.y = ip.y = e.clientY;
      }
      show();
    }, { passive: true });

    window.addEventListener('mouseleave', hideCursor);
    window.addEventListener('blur', hideCursor);

    document.addEventListener('mousedown', function () { outer.classList.add('is-clicking'); });
    document.addEventListener('mouseup', function () { outer.classList.remove('is-clicking'); });

    var hoverSel = 'a, button, input, textarea, select, summary, label, [role="button"], [data-cursor]';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest(hoverSel)) {
        outer.classList.add('is-hovering');
        inner.classList.add('is-hovering');
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest && e.target.closest(hoverSel)) {
        outer.classList.remove('is-hovering');
        inner.classList.remove('is-hovering');
      }
    });

    loop();
    window.addEventListener('beforeunload', function () { if (rafId) cancelAnimationFrame(rafId); });
  }

  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
